export enum ContactTime {
  MORNING = 'Morning',
  NOON = 'Noon',
  EVENING = 'Evening',
}
